import AbstractExpressGateway from './AbstractExpressGateway';

class LinkCheckoutGateway extends AbstractExpressGateway {

    type = 'link';

    constructor(props) {
        super(props);
        this.capabilities = [
            ...this.capabilities,
            'form_validation'
        ]
    }

}

export default LinkCheckoutGateway;